import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(site)/(main)/layout.tsx");
